const state = {
    nomeJogador: '',
    mensagemFinal: ''
};

const getters = {};

const mutations = {
    setNomeJogador(state, value) {
        state.nomeJogador = value;
    },

    setMensagemFinal(state, value) {
        state.mensagemFinal = value;
    }
};

const actions = {};

export default {
    state,
    getters,
    mutations,
    actions
}
